
import queryString from 'query-string';

import { post, put, get } from 'Api';

const language = window.locale || 'en';

/**
 *  Retrieve user tags for a product
 * @type {String} productId
 * @return {Array} user tags
 */
const getSuggestedTagsByProductId = async (productId) => {
  const { response, data } = await get([], `/products/tags/get-suggested-by-product-id/${productId}/${language}`);
  if (response.ok) return data;

  throw new Error(data.message || response.status);
};


const getFanFavourites = async ({ hitsPerPage, onSale, newReleases }) => {
  let recommendations = [];
  let url = `/products/get-fan-favourites?hitsPerPage=${hitsPerPage}&language=${language}`;

  if (onSale) {
    url = `/products/get-fan-favourites?hitsPerPage=${hitsPerPage}&onSale=true&excludeGiveaway=true&language=${language}`;
  }

  if (newReleases) {
    url = `/products/get-fan-favourites?hitsPerPage=${hitsPerPage}&language=${language}&newReleases=true`;
  }

  try {
    const { response, data } = await get([], url);
    if (response.ok) recommendations = data;
  } catch (ex) { /* */ }

  return recommendations;
};

const excludedProducts = [
  '60216687fc86df00869cbbc6', // Fanatical Spin to Win
  '60fa8aa1f0094600764ac61f', // Summer Sale Spin to Win
  '609542ed6f0293007da367fc', // May Madness Spin to Win
  '5fda02092a2d9100871f4867', // Secret Santa Giveaway
  '592fec44789c68307354f925', // Mystery Key Giveawayß
  '5f297d16e5364e1c83a74394', // Summer Mystery Giveaway Game
];

const createProductReviewsQuery = (page, rating, sort) => {
  const queryObject = {};

  if (page > 1) queryObject.page = page;
  if (Number(rating) > 0) queryObject.rating = rating;
  if (sort === 'recent') queryObject.sort = sort;

  return queryString.stringify(queryObject, { sort: false });
};

const getProductReviews = async (slug, query) => {
  let url = `/reviews/get-product-reviews/${slug}/${language}`;
  if (query) {
    url = `/reviews/get-product-reviews/${slug}/${language}?${query}`;
  }

  const { response, data } = await get([], url);

  if (response.ok) {
    return data;
  }

  throw response.status;
};

const submitReview = async (review) => {
  let result = {};
  try {
    const { response, data } = await post([], '/user/reviews/submit-review', review);
    if (response.ok) result = data;
  } catch (ex) { /* */ }
  return result;
};

const submitRecommended = async (review) => {
  let recommended;
  try {
    const { response, data } = await post([], '/user/reviews/submit-recommended', review);
    if (response.ok) recommended = data.recommended;
  } catch (ex) { /* */ }
  return recommended;
};

const submitRating = async (review) => {
  let rating;
  try {
    const { response, data } = await post([], '/user/reviews/submit-rating', review);
    if (response.ok) rating = data.rating;
  } catch (ex) { /* */ }
  return rating;
};

const reportUserReview = async (reportData) => {
  let status = false;
  try {
    const { response, data } = await put([], '/user/reviews/report-review/', reportData);

    if (response.ok) status = data.status;
  } catch (ex) { /* */ }
  return status;
};

const canUserSubmitReview = async (productId, slug) => {
  let status = { review: {}, canSubmit: {} };
  try {
    const { response, data } = await get([], `/user/reviews/can-user-submit-review/${productId}/${slug}`);
    if (response.ok) status = data;
  } catch (ex) { /* */ }
  return status;
};

const canUserReportReview = async (reviewId, versionId) => {
  let status = false;
  try {
    const { response, data } = await get([], `/user/reviews/can-user-report-review/${reviewId}/${versionId}`);
    if (response.ok) status = data.status;
  } catch (ex) { /* */ }
  return status;
};

const likeReview = async (reviewId) => {
  let likeCount;
  try {
    const { response, data } = await put([], `/user/reviews/like-review/${reviewId}`);
    if (response.ok) likeCount = data.like_count;
  } catch (ex) { /* */ }
  return likeCount;
};

const undoLikeReview = async (reviewId) => {
  let likeCount;
  try {
    const { response, data } = await put([], `/user/reviews/undo-like-review/${reviewId}`);
    if (response.ok) likeCount = data.like_count;
  } catch (ex) { /* */ }
  return likeCount;
};

const getUserLikedBySlug = async (slug) => {
  let likes = [];
  try {
    const { response, data } = await get([], `/user/reviews/get-user-liked-by-slug/${slug}`);
    if (response.ok) likes = data.user_likes;
  } catch (ex) { /* */ }
  return likes;
};

const getOrderItemReviews = async () => {
  let orderItemReviews = [];
  try {
    const { response, data } = await get([], '/user/reviews/get-order-item-reviews');
    if (response.ok) orderItemReviews = data;
  } catch (ex) { /* */ }
  return orderItemReviews;
};

const getReviewItemByProductId = async (productId) => {
  let orderItemReview = { reviewItem: {} };

  try {
    const { response, data } = await get([], `/user/reviews/get-review-item-by-product-id/${productId}`);
    if (response.ok) orderItemReview = data;
  } catch (ex) { /* */ }
  return orderItemReview;
};

const getReviewsByUserId = async () => {
  let orderItemReview = [];
  try {
    const { response, data } = await get([], '/user/reviews/get-reviews-by-user-id');
    if (response.ok) orderItemReview = data.reviews;
  } catch (ex) { /* */ }
  return orderItemReview;
};

const deleteReview = async (reviewId) => {
  let status = [];
  try {
    const { response, data } = await put([], `/user/reviews/delete-review/${reviewId}`);
    if (response.ok) status = data.deleted;
  } catch (ex) { /* */ }
  return status;
};


export {
  createProductReviewsQuery,
  getProductReviews,
  submitReview,
  submitRecommended,
  submitRating,
  reportUserReview,
  likeReview,
  undoLikeReview,
  getUserLikedBySlug,
  canUserReportReview,
  getOrderItemReviews,
  getReviewItemByProductId,
  canUserSubmitReview,
  getReviewsByUserId,
  deleteReview,
  excludedProducts,
  getSuggestedTagsByProductId,
  getFanFavourites,
};

